export default "<div class=\"ut-popup-panel inner-shadow-top\"></div>";